import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Fab, Card, InputAdornment, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import SearchData from "../components/SearchData";
import api from "../../../components/services/api";
import useDebounce from "../../../libs/hooks/useDebounce";
import DowloadBT from "../components/dowloadBT";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import {
  GridToolbarContainer,
  GridToolbarExport,
  gridClasses,
} from "@mui/x-data-grid";
const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  // textField: {
  //   marginLeft: theme.spacing(1),
  //   marginRight: theme.spacing(1),
  //   width: 100,
  // },
  // dense: {
  //   marginTop: theme.spacing(2),
  // },
  menu: {
    width: 100,
  },
}));
function CustomToolbar() {
  return (
    <GridToolbarContainer className={gridClasses.toolbarContainer}>
      <GridToolbarExport
        style={{
          color: "#84BD5A",
          borderColor: "#84BD5A",
          border: "1px solid #84BD5A",
        }}
        printOptions={{ disableToolbarButton: true }}
        csvOptions={{
          fields: ["ContainerTypeNo", "ContainerTypeName", "Size","type",'Status'],
          fileName: "ContainerList " + new Date() + Math.random(),
        }}
      />
    </GridToolbarContainer>
  );
}
export default function ContainerPage() {
  const classes = useStyles();
  const MenuActive = useSelector((state) => state.MenuActive.List);
  const [data, setData] = useState([]);
  const [key,setKey] = useState('')
  
  const debouncedKey = useDebounce(key, 500);const [dataFilter, setDataFilter] = useState([]);

  /* table data */
  const columns = [
    { field: "ContainerTypeNo", headerName: "Container no.", width: 200 },
    { field: "ContainerTypeName", headerName: "Container name", width: 200 },
    { field: "Size", headerName: "Size", width: 200 },
    { field: "TareWeight", headerName: "Weight", width: 200 },
    {
      field: "type",
      headerName: "Type",
      width: 200,
      valueGetter: (params) => {
        return params.getValue(params.id, "Type");
      },
    },
    {
      field: "Status",
      headerName: "Status",
      width: 250,
      valueFormatter: ({ value }) =>
        value === true ? "ACTIVE" : "INACTIVE",
    },
    {
      field: "Action",
      width: 130,
      sortable: false,
      renderCell: (params) => {
        const onClickEdit = async () => {
          let id = params.id;
          console.log(id);
        };
        return (
          <>
            <Link
              to={{
                pathname: `/Setting/EditContainer/${params.id}`,
              }}
            >
              <Button
                variant="contained"
                style={{ textTransform: "none", backgroundColor: "#007BFF" }}
              >
                Edit
              </Button>
            </Link>
          </>
        );
      },
    },
  ];

  //Floating Button
  const floating_action_style = {
    margin: 0,
    top: "auto",
    right: 20,
    bottom: 10,
    left: "auto",
    position: "fixed",
  };

  const fetchContainerList = async () => {
    try {
      const result = await api.get(`api/container/list?keyword=${debouncedKey}`);
      setData(result.data);
      setDataFilter(result.data);
    } catch (error) {
      console.log("error => ", error);
    }
  };

  useEffect(() => {
    fetchContainerList();
  }, [debouncedKey]);

  return (
    <div>
      <Card
        variant="outlined"
        style={{ padding: "20px", margin: "25px", height: "86vh" }}
      >
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          ประเภทตู้คอนเทนเนอร์
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Container
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / container
            </Typography>
          </Grid>
        </Grid>

        <Grid
          //   container
          //   sx={{ justifyContent: "end" }}
          style={{ marginTop: "10px", display: "flex", flexDirection: "row",justifyContent:'end' }}
        >
          {/* <DowloadBT /> */}

          <TextField
           InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            disableUnderline: true,
          }}
          label="Search"
          onChange={e => setKey(e.target.value)}
          size="small"
        />
        </Grid>

        <Box
          sx={{
            height: 650,
            width: "100%",
            marginTop: "10px",
            "& .Active": {
              color: "#28A745",
            },
            "& .Inactive": {
              color: "#F53C56",
            },
          }}
        >
          <DataGrid
            getRowId={(r) => r.ContainerTypeId}
            rows={dataFilter}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            hideFooterSelectedRowCount
            disableColumnFilter
            disableColumnMenu
            getCellClassName={(params) => {
              if (params.field === "Status") {
                return params.value === true ? "Active" : "Inactive";
              }
            }}
            components={{
              Toolbar: CustomToolbar,
            }}
          />
        </Box>
      </Card>
      {MenuActive.find((x) => x.ActionNo === "A069") && (
        <Link to="/Setting/AddContainer">
          <Fab color="primary" style={floating_action_style} aria-label="add">
            <AddIcon />
          </Fab>
        </Link>
      )}
    </div>
  );
}
